import { render, staticRenderFns } from "./InterviewQuiz.vue?vue&type=template&id=38fdb207&"
import script from "./InterviewQuiz.vue?vue&type=script&lang=js&"
export * from "./InterviewQuiz.vue?vue&type=script&lang=js&"
import style0 from "./InterviewQuiz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports